export default __webpack_public_path__ + "6967a923cb05095ea52058108b2652c6.png";